import { render } from "./Detail.vue?vue&type=template&id=65e24e18&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=65e24e18&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65e24e18"

export default script